import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { useIsOnline } from '../hooks';

/**
 * Await to become online before triggering render, after which *always* render
 * @param props.children children to render
 * @param props.whileAwaitRender render function to show while offline
 * @returns renderer
 */
function AwaitOnlineRender(props: {
    fallback?: () => JSX.Element;
    children?: ReactNode;
}): JSX.Element | null {
    const isOnline = useIsOnline();
    const [show, setShow] = useState(isOnline);

    useEffect(() => {
        if (isOnline) {
            setShow(true);
        }
    }, [isOnline]);

    const fallback = props.fallback?.() ?? null;

    return <>{show ? props.children : fallback}</>;
}

export default AwaitOnlineRender;
